import { httpPost } from "@cirrus/core/http"

import {
	AuthCirrusPlatformCredentials,
	AuthCredentials,
	AuthKeycodeCredentials,
	AuthRequestParams,
	AuthRequestPayload,
	AuthResponse
} from "./types"
import { LanguageCode } from "../../../CustomerInfo/types"
import { FrontendConfig } from "../../../FrontendConfig/types"

type LoginPreferences = {
	loggedInByKeycode?: boolean,
	language: LanguageCode,
	loggedInAsUser?: boolean,
}

export class LoginService {
	private config: FrontendConfig | null = null

	constructor(args: Partial<LoginService> & { config: FrontendConfig }) {
		for (const key in args) {
			this[key] = args[key]
		}
	}

	login = (payload: AuthRequestPayload, params?: AuthRequestParams) => {
		return httpPost<AuthResponse>("/oauth/token", payload, {
			headers: { "Content-Type": "multipart/form-data" },
			params
		})
	}

	loginWithSaml = async () => {
		if (!this.config) throw new Error("Config not found")

		const { SSOApiHost, Customer } = this.config
		window.location.assign(`${SSOApiHost}/${Customer}/saml2/login`)
	}

	resetPassword = async (payload: FormData) => {
		if (!this.config) throw new Error("Config not found")

		payload.append("customerName", this.config.Customer)
		return httpPost<string>("/api/v1/account/password/reset", payload, {
			headers: { "Content-Type": "multipart/form-data" },
		})
	}

	confirmResetPassword = async (payload: FormData) => {
		if (!this.config) throw new Error("Config not found")

		payload.append("customerName", this.config.Customer)
		return httpPost<string>("/api/v1/account/password/reset-confirm", payload, {
			headers: { "Content-Type": "multipart/form-data" },
		})
	}

	persistLoginPreferences = ({ loggedInByKeycode, language, loggedInAsUser }: LoginPreferences) => {
		sessionStorage.setItem("loggedInByKeycode", String(loggedInByKeycode ?? false))
		sessionStorage.setItem("loginLang", language)
		sessionStorage.setItem("loggedInAsUser", String(loggedInAsUser ?? false))
	}

	toAuthPayload = (credentials: AuthCredentials): AuthRequestPayload => {
		const formData = new FormData()

		for (const key in credentials) {
			formData.append(key, credentials[key])
		}

		return formData
	}

	getAuthTokens = () => ({
		authorToken: sessionStorage.getItem("author-token"),
		deliveryToken: sessionStorage.getItem("delivery-token"),
		browserToken: localStorage.getItem("browser-token"),
	})

	persistBrowserToken = (token: string) => localStorage.setItem("browser-token", token)

	// Uses for 2FA
	storeCredentials = (credentials: AuthKeycodeCredentials | AuthCirrusPlatformCredentials): void => {
		sessionStorage.setItem("credentials", JSON.stringify(credentials))
	}
	getStoredCredentials = (): AuthKeycodeCredentials | AuthCirrusPlatformCredentials | null => {
		const storedCredentials = sessionStorage.getItem("credentials")
		return storedCredentials ? JSON.parse(storedCredentials) : null
	}
	removeStoredCredentials = (): void => {
		sessionStorage.removeItem("credentials")
	}
}
